import { makeApi } from "@zodios/core";
import { z } from "zod";

import { EAbusiveReportType } from "@/types/backoffice/dto/subscriber-feedback/abusive-report-type.ts";
import { siteSupportAbuseDtoSchema } from "@/types/backoffice/dto/support/site-support-abuse-dto.ts";

export const backofficeSupportApi = makeApi([
  {
    method: "get",
    path: "/site/:siteId/abuse",
    response: siteSupportAbuseDtoSchema,
    alias: "findSiteSupportAbuse",
  },
  {
    method: "post",
    path: "/site/:siteId/abuse",
    response: z.any(),
    alias: "sendSiteSupportAbuse",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: z.object({
          abuseReasonId: z.number(),
          abusiveOperatorType: z.nativeEnum(EAbusiveReportType),
          appointmentId: z.number(),
          comment: z.string(),
        }),
      },
    ],
  },
]);
